var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100vh"}},[_c('div',{staticClass:"funcionalidade-handler",attrs:{"id":"func-handler"}})])
}]

export { render, staticRenderFns }